import { SettingConst } from '../../types';

/**
 * Controls whether test mode should be enabled. CAUTION: This will make the background of +LayoutElements red for testing purposes, should never be true on production.
 */
export const SERVER_DRIVEN_UI_TEST_MODE_ENABLED_240314 =
  'SERVER_DRIVEN_UI_TEST_MODE_ENABLED_240314' as SettingConst<
    'SERVER_DRIVEN_UI_TEST_MODE_ENABLED_240314',
    boolean,
    'RETAILER' | 'RETAILER_ANDROID' | 'RETAILER_IOS'
  >;
